import { useAxios } from '../utils/axiosConfig';
import { useNotification } from "../contexts/NotificationContext";
import config from '../contexts/ConfigContext';
import { AuditEntriesModel } from 'components/History Tracking/AuditComponent';

export interface FilterModel {
    Tags: string[];
    WhereType: number;
}

export interface LabelModel {
    ProjectId: number;
    ObjectIds: number[];
}

export interface ParentModel {    
    ParentId: number;
    LabelIds: number[];
}

export class LabelService {

    axios = useAxios();
    // Define the notification hook
    notification = useNotification();    

    // Call the API to get the filters for the current user and project
    async GetMyProjectLabelsFilter(): Promise<FilterModel> {
        try {
            const response = await this.axios.get(`${config.API_URL}/api/ProjectLabels/GetMyFilter`);
            return response.data;
        } catch (error) {
            // Handle error
            this.notification.showNotification('Error fetching filters: ' + error, 'error');
            console.error('Error fetching filters:', error);
            return { Tags: [], WhereType: 1 };
        }
    }
    // Call the API to update the filters for the current user and project
    async UpdateMyProjectLabelsFilter(filterModel: FilterModel): Promise<void> {
        try {
            const response = await this.axios.post(`${config.API_URL}/api/ProjectLabels/UpdateMyFilter`, filterModel);
            return response.data;
        } catch (error) {
            // Handle error
            this.notification.showNotification('Error fetching labels: ' + error, 'error');
            console.error('Error fetching labels:', error);
            
        }
    }

    // Call the API to add labels to the current project
    async AddLabelsToProject(labelModel: LabelModel): Promise<void> {
        try {
            const response = await this.axios.post(`${config.API_URL}/api/ProjectLabels/AddLabelToProject`, labelModel);
            return response.data;
        } catch (error) {
            // Handle error
            this.notification.showNotification('Error add labels: ' + error, 'error');
            console.error('Error add labels:', error);
            
        }
    }

    // Call the API to remove labels from the current project
    async RemoveLabelsFromProject(labelModel: LabelModel): Promise<void> {
        try {
            const response = await this.axios.post(`${config.API_URL}/api/ProjectLabels/RemoveLabelFromProject`, labelModel);
            return response.data;
        } catch (error) {
            // Handle error
            this.notification.showNotification('Error remove labels: ' + error, 'error');
            console.error('Error remove labels:', error);
            
        }
    }

    // Call the API to get the filters for the current user and project
    async GetMyLabelsFilter(): Promise<FilterModel> {
        try {
            const response = await this.axios.get(`${config.API_URL}/api/Labels/GetMyFilter`);
            return response.data;
        } catch (error) {
            // Handle error
            this.notification.showNotification('Error fetching filters: ' + error, 'error');
            console.error('Error fetching filters:', error);
            return { Tags: [], WhereType: 1 };
        }
    }
    // Call the API to update the filters for the current user and project
    async UpdateMyLabelsFilter(filterModel: FilterModel): Promise<void> {
        try {
            const response = await this.axios.post(`${config.API_URL}/api/Labels/UpdateMyFilter`, filterModel);
            return response.data;
        } catch (error) {
            // Handle error
            this.notification.showNotification('Error fetching labels: ' + error, 'error');
            console.error('Error fetching labels:', error);
            
        }
    }

    async SetParentLabel (parentModel: ParentModel): Promise<void> {
        try {
            const response = await this.axios.post(`${config.API_URL}/api/ProjectLabels/SetParent`, parentModel);
            return response.data;
        } catch (error) {
            // Handle error
            this.notification.showNotification('Error set parent label: ' + error, 'error');
            console.error('Error set parent label:', error);
            
        }
    }

    async GetAudit(labelId: number): Promise<AuditEntriesModel[]>{
        try {
            const response = await this.axios.get(config.API_URL + "/api/Labels/GetAudit?labelId=" + labelId);
            return response.data;
        }
        catch (error: any) {
            this.notification.showNotification("Error getting label audit history: " + error, 'error');
            console.error("Error getting label audit history: ", error);
            return {} as AuditEntriesModel[];
        }
    }
}